/*
 * Appeals Reducer
 *
 * The reducer takes care of our data. Using actions, we can change our
 * application state.
 * To add a new action, add it to the switch statement in the reducer function
 *
 */

import { ActionTypesInquiry, InquiriesInititalState } from './constants';
import { InquiriesInitialStateType, InquiryHeader, InquirySearchParams } from './types';

// The initial state of the App
const initialState: InquiriesInitialStateType = {
  inquirySearchId: '',
  inquiryGridData: [],
  inquiryHeaderDetails: {} as InquiryHeader,
  inquiryMessagesData: [],
  showInquirySearchGrid: false,
  isInquiryLoading: false,
  isInquiryHeaderLoading: false,
  isInquiryMessagesLoading: false,
  isInquiryLookupLoading: false,
  isAddResponseLoading: false,
  inquirySearchParams: {} as InquirySearchParams,
  inquiryAdvancedSearchLookupData: null,
  isInquiryAttachmentInfoLaoding: false,
  inquiryAttachmentInfoData: [],
  isInquiryActivityInfoLoading: false,
  inquiryActivityInfoData: [],
  isDetailPaneLoading: false,
  isCloseInquiryLoading: false,
  isInquiryCategoryLoading: false,
  inquiryCatergory: [],
  inquiryGridColumnConfig: [],
};

function inquiriesReducer(state = initialState, action) {
  switch (action.type) {
    case ActionTypesInquiry.SET_INQUIRY_SEARCH_ID:
      return {
        ...state,
        inquirySearchId: action.searchId,
      };
    case ActionTypesInquiry.SET_INQUIRY_SEARCH_GRID:
      return {
        ...state,
        inquiryGridData: action.gridData,
      };
    case ActionTypesInquiry.SET_INQUIRY_GRID_COLUMN_CONFIG:
      return {
        ...state,
        inquiryGridColumnConfig: action.payload,
      };
    case ActionTypesInquiry.SET_INQUIRY_MESSAGES:
      return {
        ...state,
        inquiryMessagesData: action.inquiryMessagesData,
      };
    case ActionTypesInquiry.SET_INQUIRY_HEADER:
      return {
        ...state,
        inquiryHeaderDetails: action.inquiryHeaderDetails,
      };
    case ActionTypesInquiry.SET_INQUIRY_SEARCH_PARAMS:
      return {
        ...state,
        inquirySearchParams: action.inquirySearchParams,
      };
    case ActionTypesInquiry.TOGGLE_SHOW_INQUIRY_SEARCH_GRID:
      return {
        ...state,
        showInquirySearchGrid: action.showSearchGrid,
      };
    case ActionTypesInquiry.TOGGLE_INQUIRY_LOADING:
      return {
        ...state,
        isInquiryLoading: action.isLoading,
      };
    case ActionTypesInquiry.CLEAR_INQUIRIES_SEARCH_PANE_REDUX_DATA:
      return {
        ...state,
        inquirySearchId: '',
        inquiryGridDate: [],
        showInquirySearchGrid: false,
      };
    case ActionTypesInquiry.TOGGLE_INQUIRY_HEADER_LOADING:
      return {
        ...state,
        isInquiryHeaderLoading: action.isInquiryHeaderLoading,
      };
    case ActionTypesInquiry.TOGGLE_INQUIRY_MESSAGES_LOADING:
      return {
        ...state,
        isInquiryMessagesLoading: action.isInquiryMessagesLoading,
      };
    case ActionTypesInquiry.SET_INQUIRY_ADVANCED_SEARCH_LOOPKUP_DATA:
      return {
        ...state,
        inquiryAdvancedSearchLookupData: action.lookupData,
      };
    case ActionTypesInquiry.TOGGLE_INQUIRY_ADVANCED_SEARCH_LOOPKUP_LOADING:
      return {
        ...state,
        isInquiryLookupLoading: action.isLoading,
      };
    case ActionTypesInquiry.TOGGLE_INQUIRY_ATTACHMENTS_LOADING:
      return {
        ...state,
        isInquiryAttachmentInfoLaoding: action.isLoading,
      };
    case ActionTypesInquiry.SET_INQUIRY_ATTACHMENT_INFO_DATA:
      return {
        ...state,
        inquiryAttachmentInfoData: action.data,
      };
    case ActionTypesInquiry.SET_INQUIRY_ACTIVITY_INFO_DATA:
      return {
        ...state,
        inquiryActivityInfoData: action.data,
      };

    case ActionTypesInquiry.TOGGLE_INQUIRY_ACTIVITY_INFO_LOADING:
      return {
        ...state,
        isInquiryActivityInfoLoading: action.isLoading,
      };
    case ActionTypesInquiry.CLEAR_INQUIRIES_DETAIL_PANE_REDUX_DATA:
      return {
        ...state,
        ...InquiriesInititalState,
        inquiryGridColumnConfig: state.inquiryGridColumnConfig,
      };
    case ActionTypesInquiry.TOGGLE_DETAIL_PANE_LOADING:
      return {
        ...state,
        isDetailPaneLoading: action.isDetailPaneLoading,
      };
    case ActionTypesInquiry.TOGGLE_ADD_RESPONSE_LOADING:
      return {
        ...state,
        isAddResponseLoading: action.isAddResponseLoading,
      };
    case ActionTypesInquiry.TOGGLE_CLOSE_INQUIRY_LOADING:
      return {
        ...state,
        isCloseInquiryLoading: action.isLoading,
      };
    case ActionTypesInquiry.TOGGLE_INQUIRY_CATEGORY_LOADING:
      return {
        ...state,
        isInquiryCategoryLoading: action.isLoading,
      };
    case ActionTypesInquiry.SET_INQUIRY_CATEGORY_DATA:
      return {
        ...state,
        inquiryCatergory: action.data,
      };
    default:
      return state;
  }
}

export default inquiriesReducer;
